import { Box } from "@mui/material";
import { useCallback, useState } from "react";
import TruncatedTextTooltip from "../TruncatedTextTooltip";
import {
  gridColors,
  handleOpenAppDetailDialogAndPassDetails,
} from "../constants";
import CollectionDetailDialog from "./CollectionDetailDialog";
import { gridBackgroundLayout, loaderImg } from "../images";

const gridBGImage = (
  <img
    src={gridBackgroundLayout}
    width="100%"
    alt=""
    style={{
      position: "absolute",
      top: "0",
      right: "0",
      height: "100%",
      pointerEvents: "none",
    }}
  />
);
const Grid = ({ collectionData, title, idx, collectionId }) => {
  const [isOpenDetailPage, setIsOpenDetailPage] = useState(false);

  const handleOpenDetailDialog = useCallback((data) => {
    const { id } = data;
    handleOpenAppDetailDialogAndPassDetails({
      id,
    });
  }, []);

  return (
    <Box className="grid-wrapper" bgcolor={gridColors[idx % gridColors.length]}>
      {gridBGImage}
      <Box zIndex="99" position="relative">
        <TruncatedTextTooltip
          textProps={{
            className: "white-text-only cursor-pointer",
            font: "bold",
          }}
          textValue={title}
          fontSize={20}
          cellWidth="100%"
          boxProps={{
            onClick: () => setIsOpenDetailPage(true),
          }}
        />

        <Box className="grid">
          {collectionData?.map((data) => {
            const { logo_images, display_name, id } = data;
            let imgSrc = logo_images?.original || loaderImg;
            return (
              <Box
                className="grid-data"
                onClick={() => handleOpenDetailDialog(data)}
                sx={{ cursor: "pointer" }}
                key={id}
              >
                <img
                  alt={display_name}
                  src={imgSrc}
                  height="70px"
                  width="70px"
                  className="grid-image"
                  onError={(e) => {
                    e.target.src = loaderImg;
                  }}
                />
                <TruncatedTextTooltip
                  textProps={{
                    className: "white-text-only header-account-name",
                    font: "semibold",
                  }}
                  textValue={display_name}
                  fontSize={12}
                  cellWidth="70px"
                />
              </Box>
            );
          })}
        </Box>
      </Box>
      {isOpenDetailPage && (
        <CollectionDetailDialog
          isOpen={isOpenDetailPage}
          setIsOpen={setIsOpenDetailPage}
          collectionName={title}
          collectionId={collectionId}
        />
      )}
    </Box>
  );
};

export default Grid;
